/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { useDataContext } from '../context';

const API_URL = import.meta.env.VITE_API_URL;

function GetAllUsers() { // เปลี่ยนชื่อจาก AllDepartment เป็น GetAllUsers
  const { data, setData } = useDataContext();
  
  // ตัวกันยิงซ้ำ
  const hasFetched = useRef(false);

  useEffect(() => {
    // 1. เช็คว่ามีข้อมูลใน Context หรือยัง?
    if (data.allUsersAD && data.allUsersAD.length > 0) {
        return;
    }

    // 2. เช็คว่าเคยยิงไปแล้วหรือยัง
    if (hasFetched.current) return;

    const fetchData = async () => {
      hasFetched.current = true;
      try {
        const requestOptions = {
          method: "GET",
          redirect: "follow"
        };
        
        const response = await fetch(`${API_URL}/getAllUsers`, requestOptions);
        const result = await response.json();

        setData(prevData => ({
            ...prevData, 
            allUsersAD: result.users || [] // ตามโค้ดเดิมใช้ result.users
        }));

      } catch (error) {
        console.error("Error fetching users:", error);
        hasFetched.current = false; // Reset on error
      }
    };

    fetchData();
    
  }, []); // Run once on mount

  return null;
}

export default GetAllUsers;